export type CadenceViewLinkParamProvider<
  ParamObject,
  Arguments extends any[]
> = {
  [Key in keyof ParamObject]: (...args: Arguments) => ParamObject[Key];
};
